/*
 * Shopify's predictive search only indexes a product's title, type and vendor. Terms that
 * live in a description, a tag or a SKU — "keychain", "cellophane", "Dunder Mifflin" —
 * return nothing in the dropdown even though the results page finds them. When a
 * predictive render comes back without products, fetch the full search through the
 * search-suggest section and drop those products into the dropdown instead.
 */
(() => {
  // The popdown renders in both headers and the mobile menu, and the search page adds
  // its own copy — so this file can land on a page several times over.
  if (window.__searchSuggestFallback) return;
  window.__searchSuggestFallback = true;

  const selectors = {
    predictiveSearch: 'predictive-search',
    results: '[data-predictive-search-results]',
    input: 'input[type="search"]',
    item: '.predictive-search__grid-item',
    groupsWrapper: '[data-search-results-groups-wrapper]',
    listbox: '#predictive-search-results',
    actions: '.predictive-search__actions',
    message: '.predictive-search__message',
    suggest: '[data-search-suggest]',
  };

  const cache = new Map();

  document.querySelectorAll(selectors.predictiveSearch).forEach((root) => {
    const results = root.querySelector(selectors.results);
    const input = root.querySelector(selectors.input);
    if (!results || !input) return;

    // The theme replaces the whole innerHTML on every render, so watching direct
    // children is enough — and keeps our own nested insert from re-triggering us.
    new MutationObserver(() => hydrate(results, input)).observe(results, {childList: true});
  });

  function hydrate(results, input) {
    if (results.querySelector(selectors.item)) return; // predictive found products itself
    if (results.querySelector(selectors.suggest)) return; // already filled this render

    const terms = input.value.trim();
    if (!terms) return;

    fetchSuggestions(terms).then((markup) => {
      if (!markup) return;
      // Bail if the shopper kept typing or the theme re-rendered with real results.
      if (input.value.trim() !== terms) return;
      if (results.querySelector(selectors.item) || results.querySelector(selectors.suggest)) return;

      const column = new DOMParser().parseFromString(markup, 'text/html').querySelector(selectors.suggest);
      if (!column) return;

      column.querySelectorAll('[data-aos]').forEach((element) => {
        ['data-aos', 'data-aos-delay', 'data-aos-duration', 'data-aos-anchor'].forEach((attribute) =>
          element.removeAttribute(attribute)
        );
      });

      const wrapper = results.querySelector(selectors.groupsWrapper);
      if (wrapper) {
        wrapper.appendChild(column);
      } else {
        const listbox = results.querySelector(selectors.listbox) || results;
        listbox.insertBefore(column, listbox.querySelector(selectors.actions));
      }

      results.querySelector(selectors.message)?.remove();
    });
  }

  function fetchSuggestions(terms) {
    if (cache.has(terms)) return Promise.resolve(cache.get(terms));

    const url =
      `${window.theme.routes.root}search?q=${encodeURIComponent(terms)}` +
      '&type=product&options%5Bprefix%5D=last&section_id=search-suggest';

    return fetch(url)
      .then((response) => (response.ok ? response.text() : ''))
      .then((text) => {
        cache.set(terms, text);
        return text;
      })
      .catch(() => '');
  }
})();
